import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoNovedadPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoNovedad {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoNovedadResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoNovedadService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_novedad`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<TipoNovedad[]> {
    return this.http.get<TipoNovedad[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<TipoNovedad> {
    return this.http.get<TipoNovedad>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear
  create(
    payload: TipoNovedadPayload
  ): Observable<TipoNovedadResponse> {
    return this.http.post<TipoNovedadResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<TipoNovedadPayload>
  ): Observable<TipoNovedadResponse> {
    return this.http.put<TipoNovedadResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar
  inactivar(id: number): Observable<TipoNovedadResponse> {
    return this.http.put<TipoNovedadResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar
  activar(id: number): Observable<TipoNovedadResponse> {
    return this.http.put<TipoNovedadResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}